import script from "./DeletedVideoItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeletedVideoItem.vue?vue&type=script&lang=ts&setup=true"

import "./DeletedVideoItem.vue?vue&type=style&index=0&id=b588936c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b588936c"]])

export default __exports__